import Axios from "axios";
import config from "../config";


const AuthService = {
	

	isKeyValid() {
		const expiryTime = window.localStorage.getItem("spaceio-key-expiry");
		const now = Date.now();
		return Number(now) <= Number(expiryTime);
	},

	async fetchAuthKey() {
		let key = AuthService.authKey;
		if (AuthService.isKeyValid()) {
			return key
		};
		const newAuthKey = await this.refreshTokenAPI(AuthService.refreshToken);
		return newAuthKey;
	},

	get refreshToken() {
		let key = window.localStorage.getItem("spaceio-refresh-token");
		if (key === null) {
			return null
		};
		return key;
	},

	set refreshToken(key) {
		if (!key) return;
		window.localStorage.setItem("spaceio-refresh-token", key);
	},

	get authKey() {
		let key = window.localStorage.getItem("spaceio-key");
		if (key === null) return null
		return key;
	},

	set authKey(key) {
		if (!key) return;
		window.localStorage.setItem("spaceio-key", key);
	},

	getAuthToken: async (authCode) => {
		try {
			const res = await Axios({
				headers: {
					"x-auth-code": authCode,
				},
				method: 'post',
				url: `${config.PRODWS_URL}/api/login/code?requiredRefreshToken=true`
			});
			const { 'x-auth-key': newAuthKey, 'x-auth-keyexpiry': expiry, 'x-refresh-token': refreshToken } = res.headers;

			AuthService.authKey = newAuthKey;
			AuthService.refreshToken = refreshToken;
			window.localStorage.setItem('spaceio-key-expiry', Date.now() + Number(expiry));
		} catch (err) {
			console.error(err);
			throw (err.response.data.error)
		}
	},
	authenticationKey: function () {
		return localStorage.getItem("spaceio-key") ? localStorage.getItem("spaceio-key") : null
	},

	logout: () => {
		window.localStorage.removeItem("spaceio-key");
	},

	refreshTokenAPI: async (refreshKey) => {
		try {
			const res = await Axios({
				headers: {
					"x-refresh-token": refreshKey,
				},
				method: 'post',
				url: `${config.PRODWS_URL}/api/refresh-token?requiredRefreshToken=true`
			});
			const { 'x-auth-key': newAuthKey, 'x-auth-keyexpiry': expiry, 'x-refresh-token': refreshToken } = res.headers;

			AuthService.authKey = newAuthKey;
			AuthService.refreshToken = refreshToken;
			window.localStorage.setItem('spaceio-key-expiry', Date.now() + Number(expiry));

			return newAuthKey;
		} catch (err) {
			console.error(err);
			console.error(err);
			throw (err.response.data.error)
		}
	},


	//Based on Product Id fetches floor ID & Name if that product is present on that floor
	getFloorIdAndNameUsingProductId: async (authKey, productId) => {
		try {
			const res = await Axios.get(`${config.PRODWS_URL}/api/admin/${productId}/locations`, {
				headers: {
					"x-auth-key": await AuthService.fetchAuthKey()
				}
			});
			return res.data;
		} catch (err) {
			console.error(err);
			throw (err.response.data.error)
		}
	},

	getProductIdAndNameUsingProductId: async (authKey) => {
		try {
			const res = await Axios.get(`${config.PRODWS_URL}/api/admin/searchProducts`, {
				headers: {
					"x-auth-key": await AuthService.fetchAuthKey()
				}
			});
			return res.data;
		} catch (err) {
			console.error(err);
			throw (err.response.data.error)
		}
	},

	getFloorDetails: async (authKey, floorId) => {
		try {
			const res = await Axios.get(`${config.PRODWS_URL}/api/admin/locations/${floorId}`, {
				headers: {
					"x-auth-key": await AuthService.fetchAuthKey()
				}
			});
			return [res.data];
		} catch (err) {
			console.error(err);
			throw (err.response.data.error)
		}
	},

	readBTIMStatus: async (agentId) => {
		try {
			const res = await Axios.get(`${config.ELECTRIC_URL}/${agentId}/BTIM/currentStatus`, {
				headers: {
					"Authorization": await AuthService.fetchAuthKey()
				},
			},
			);
			return res.data;
		} catch (err) {
			console.error(err);
			throw (err.response.data)
		}
	},

	sendDebugStatusToBatTim: async (debugModeFlag, agentId) => {

		let myHeaders = new Headers();
		myHeaders.append("Content-Type", "application/json");
		let raw = JSON.stringify({
			"utcTime": 0,
			"debugModeFlag": debugModeFlag,
			"debugModeOnTime": 5,
			"maxDebugModeOnTime": 0
		});
		let url = `${config.ELECTRIC_AGENT_URL}/${agentId}/BTIM/debugMode`;
		let requestOptions = {
			method: 'POST',
			headers: myHeaders,
			body: raw,
			redirect: 'follow'
		};

		try {
			const response = await fetch(url, requestOptions);
			return response.status
			// Use the responseText as needed
		} catch (error) {
			console.error('Error:', error);
		}
	},

	sendCalibration: async (forceCalibrationFlag, agentId) => {

		let myHeaders = new Headers();
		myHeaders.append("Content-Type", "application/json");
		let raw = JSON.stringify({
			"utcTime": 0,
			"forceCalibrationFlag": forceCalibrationFlag
		});
		let url = `${config.ELECTRIC_AGENT_URL}/${agentId}/BTIM/forceCalibration`;
		let requestOptions = {
			method: 'POST',
			headers: myHeaders,
			body: raw,
			redirect: 'follow'
		};

		try {
			const response = await fetch(url, requestOptions);
			return response.status
			// Use the responseText as needed
		} catch (error) {
			console.error('Error:', error);
		}
	},


	locationAPI: async (authKey, floorId) => {
		try {
			const res = await Axios.get(`${config.PRODWS_URL}/api/locations/${floorId}`, {
				headers: {
					"x-auth-key": await AuthService.fetchAuthKey(),
				}
			});

			return res.data;
		} catch (err) {
			console.error(err);
			throw (err.response.data.error)
		}
	},


	getFloorSpaces: async (authKey, floorId, spaceId) => {
		try {
			const res = await Axios.get(`${config.PRODWS_URL}/api/locations/${floorId}/spaces`, {
				headers: {
					"x-auth-key": await AuthService.fetchAuthKey()
				}
			});
			res.data.map((s) => {
				// console.log("s", { sId: s.id, stoye: typeof s.id, spaceId, spaceIdType: Array.isArray(spaceId) })
			})
			let PolySpaces = res.data.filter((space) => {
				if (Array.isArray(spaceId)) {
					return spaceId.includes(space.id.toString())
				} else if (typeof spaceId === "string") {
					return spaceId = space.id.toString();
				} else if (typeof spaceId === "number") {
					return space.id === spaceId
				}
			});

			if (PolySpaces.length > 0) {

				
				let tempMark = PolySpaces[0].marker?.data;
				const match = tempMark.includes(";") ? tempMark.split(";")[0] : false
				if (match) {
					tempMark = parseInt(match); // Convert the matched string to an actual number
				}

				const srfx = PolySpaces[0].srf.x;
				const srfy = PolySpaces[0].srf.y;

				const result = typeof tempMark === "string" ? tempMark.includes('polygon') : false

				if (result) {
					console.log("there is polygon")
				}
				else {
					const locationAPIresponse = await AuthService.locationAPI(await AuthService.fetchAuthKey(), floorId);
					let scalingFactor = locationAPIresponse[0].scalingFactor;
					const dbdataresult = await AuthService.getTimDBSpaces(await AuthService.fetchAuthKey(), spaceId);

					if (dbdataresult && dbdataresult.length) {
						let height = dbdataresult[0].heightFromFloor;

						let width = (2.856 * height) * 0.85; /*Area width*/
						let length = 1.534 * height;/*Area height*/

						let rxWidth = width * scalingFactor;
						let ryLength = length * scalingFactor;
						let angle = dbdataresult[0].angle * Math.PI / 180;
						let [x, y] = dbdataresult[0].coordinates.split(",");
						let coordinates = [x * scalingFactor, y * scalingFactor];

						let buffer = 0.8;
						
						//top-left corner 
						let topLeftX = srfx + (-rxWidth / buffer) * Math.cos(angle) - (ryLength / buffer) * Math.sin(angle);
						let topLeftY = srfy + (-rxWidth / buffer) * Math.cos(angle) + (ryLength / buffer) * Math.sin(angle);
						let topLeft = { x: topLeftX, y: topLeftY };

						//top-right corner 
						let topRightX = srfx + (rxWidth / buffer) * Math.cos(angle) - (ryLength / buffer) * Math.sin(angle);
						let topRightY = srfy + (rxWidth / buffer) * Math.cos(angle) + (ryLength / buffer) * Math.sin(angle);
						let topRight = { x: topRightX, y: topRightY };

						//bottom-left corner 
						let bottomLeftX = srfx + (-rxWidth / buffer) * Math.cos(angle) - (-ryLength / buffer) * Math.sin(angle);
						let bottomLeftY = srfy + (-rxWidth / buffer) * Math.cos(angle) + (-ryLength / buffer) * Math.sin(angle);
						let bottomLeft = { x: bottomLeftX, y: bottomLeftY };

						//bottom-right corner
						let bottomRightX = srfx + (rxWidth / buffer) * Math.cos(angle) - (-ryLength / buffer) * Math.sin(angle);
						let bottomRightY = srfy + (rxWidth / buffer) * Math.cos(angle) + (-ryLength / buffer) * Math.sin(angle);
						let bottomRight = { x: bottomRightX, y: bottomRightY };

						let c = [topLeft, topRight, bottomRight, bottomLeft];

						var xValues = c.map(item => parseFloat(item.x.toFixed(2)));
						var yValues = c.map(item => parseFloat(item.y.toFixed(2)));
						
						var pointsString = xValues.map((x, index) => `${x},${yValues[index]}`).join(' ');
						PolySpaces[0]["marker"]["data"] = `<polygon points="${pointsString}"/>"`;

					}
				}
			}
			return PolySpaces;
		} catch (err) {
			console.error(err);
			throw (err.response.data.error)
		}
	},

	getTimDBSpaces: async (authKey, spaces) => {
		try {
			const res = await Axios.get(`${config.TIMWS_URL}/api/config/space/${spaces}`, {
				headers: {
					"x-auth-key": await AuthService.fetchAuthKey(),
				}
			});
			return res.data;
		} catch (err) {
			console.error(err);
			throw (err.response.data.error)
		}
	},
	
	getDeviceFromFloorAndProductID: async (authKey, floorId, productId) => {
		try {
			const res = await Axios.get(`${config.PRODWS_URL}/api/admin/locations/${floorId}/devices?productId=${productId}`, {
				headers: {
					"x-auth-key": await AuthService.fetchAuthKey()
				}
			});
			return res.data;
		} catch (err) {
			console.error(err);
			throw (err.response.data.error)
		}
	},


	getConfigZone: async (assetId) => {

        try {
            const res = await Axios.post(`${config.SPOTWS_URL}/assets/data/8/current`, assetId, {
                headers: {
                    "x-location-token": await AuthService.fetchAuthKey(),
                    "authorization": process.env.REACT_APP_AUTHORIZATION_KEY,
                    "Content-Type": "application/json"
                },
            },
            );
            return res.data;
        } catch (err) {
            console.error(err);
            throw (err.response.data.error)
        }
    },

	updateFLOConfig: async (dataToWrite) => {
		
		try {
			const res = await Axios.post(`${config.SPOTWS_URL}/ingest/8?asyncCall=false`, dataToWrite, {
				headers: {
					"x-location-token": await AuthService.fetchAuthKey(),
					"authorization": process.env.REACT_APP_AUTHORIZATION_KEY,
					"Content-Type": "application/json"
				},
			},
			);
			return res.data;
		} catch (err) {
			console.error(err);
			throw (err.response.data.error)
		}

	},

	coldReboot: async (agentIdArr) => {
		let myHeaders = new Headers();
		myHeaders.append("Authorization", await AuthService.fetchAuthKey());

		let requestOptions = {
			method: 'GET',
			headers: myHeaders,
			redirect: 'follow'
		};

		const response = await fetch(`${config.ELECTRIC_URL}/${agentIdArr}/FLO/newFloConfigData`, requestOptions)
		const result = await response.json();
		return result;
	},


	getRawDevices: async (authKey, floorId) => {
		try {
			const res = await Axios.get(`${config.PRODWS_URL}/api/locations/${floorId}/raw-devices`, {
				headers: {
					"x-auth-key": await AuthService.fetchAuthKey()
				}
			});
			return res.data;
		} catch (err) {
			console.error(err);
			throw (err.response.data.error)
		}
	},

	getDeviceStatus: async (agentId) => {
		let myHeaders = new Headers();
		myHeaders.append("Authorization", await AuthService.fetchAuthKey());

		let requestOptions = {
			method: 'GET',
			headers: myHeaders,
			redirect: 'follow'
		};

		const response = await fetch(`${config.ELECTRIC_URL}/${agentId}/FLO/deviceStatus`, requestOptions)
		const result = await response.json();
		return result;
	},

	getOccupanceDataforTIMP: async (authKey, assetIdarray) => {
		try {
			const res = await Axios.post(`${config.SPOTWS_URL}/assets/data/3/current`, assetIdarray, {
				headers: {
					"x-location-token": await AuthService.fetchAuthKey(),
					"authorization": process.env.REACT_APP_AUTHORIZATION_KEY,
					"Content-Type": "application/json"
				},
			},
			);
			return res.data;
		} catch (err) {
			console.error(err);
			throw (err.response.data.error)
		}
	},

	readDataSPOT: async (authKey, assetIdArr) => {
		try {
			const res = await Axios.post(`${config.SPOTWS_URL}/assets/data/22/current`, assetIdArr, {
				headers: {
					"x-location-token": await AuthService.fetchAuthKey(),
					"authorization": process.env.REACT_APP_AUTHORIZATION_KEY,
					"Content-Type": "application/json"
				},
			},
			);
			for (let i = 0; i < res.data.length; i++) {
				const data = res.data[i];
				if (!data || !data.utcEpoch) {
					let utcTimestamp = Date.now();
					const resetData = {
						"id": assetIdArr[i],
						"setup_status": 0,
						"cal_status": 0,
						"calibration_status": 0,
						"instalation_status": 0,
						"utcEpoch": utcTimestamp,
						"test_status": [
							0,
							0,
							0,
							0,
							0
						],
						"people_count": [
							0,
							0,
							0,
							0
						]
					}
					res.data[i] = resetData;
				}
			}
			return res.data;
		} catch (err) {
			console.error(err);
			throw (err.response.data.error)
		}
	},

	readDataSPOTNew: async (authKey, assetId) => {
		let myHeaders = new Headers();
		myHeaders.append("x-location-token", await AuthService.fetchAuthKey());
		myHeaders.append("authorization", process.env.REACT_APP_AUTHORIZATION_KEY);
		myHeaders.append("Content-Type", "application/json");

		let raw = JSON.stringify([
			assetId
		]);

		let requestOptions = {
			method: 'POST',
			headers: myHeaders,
			body: raw,
			redirect: 'follow'
		};
		const response = await fetch(`${config.SPOTWS_URL}/assets/data/22/current`, requestOptions);
		const result = await response.json();
		return result[0];

		
	},

	readTimPDataSPOT: async (authKey, assetIdArr) => {
		try {
			const res = await Axios.post(`${config.SPOTWS_URL}/assets/data/29/current`, assetIdArr, {
				headers: {
					"x-location-token": await AuthService.fetchAuthKey(),
					"authorization": process.env.REACT_APP_AUTHORIZATION_KEY,
					"Content-Type": "application/json"
				},
			},
			);
			return res.data;
		} catch (err) {
			throw (err.response.data.error)
		}
	},

	readTIMData: async (agentIdArr) => {
		try {
			const res = await Axios.get(`${config.ELECTRIC_URL}/${agentIdArr}/TIM/current`, {
				headers: {
					"Authorization": await AuthService.fetchAuthKey(),
				},
			},
			);
			return res.data;
		} catch (err) {
			console.error(err);
			throw (err.response.data)
		}
	},

	sendCalibrationCommand: async (agentIdArr) => {
		try {
			const res = await Axios.get(`${config.ELECTRIC_URL}/${agentIdArr}/TIM/calibration`, {
				headers: {
					"Authorization": await AuthService.fetchAuthKey(),
				},
			},
			);
			return res.data;
		} catch (err) {
			console.error(err);
			throw (err.response.data.error)
		}
	},

	increaseFrameRate: async (agentIdArr) => {
		try {
			const res = await Axios.get(`${config.ELECTRIC_URL}/${agentIdArr}/TIM/test`, {
				headers: {
					"Authorization": await AuthService.fetchAuthKey(),
				},
			},
			);
			return res.data;
		} catch (err) {
			throw (err.response.data.error)
		}
	},

	increaseBatTimFrameRate: async (testModeFlag, agentId) => {
		let myHeaders = new Headers();
		myHeaders.append("Content-Type", "application/json");
		let raw = JSON.stringify({
			"utcTime": 0,
			"testModeFlag": testModeFlag,
			"testModeOnTime": 10
		});
		let url = `https://agent.electricimp.com/${agentId}/BTIM/testMode`;
		var requestOptions = {
			method: 'POST',
			headers: myHeaders,
			body: raw,
			redirect: 'follow'
		};

		try {
			const response = await fetch(url, requestOptions);
			return response.status
		}
		catch (error) {
			throw (error.response.data.error)
		}
	},

	defaultFrameRate: async (agentIdArr) => {
		try {
			const res = await Axios.get(`${config.ELECTRIC_URL}/${agentIdArr}/TIM/defultFrameRate`, {
				headers: {
					"Authorization": AuthService.authenticationKey(),
				},
			},
			);
			return res.data;
		} catch (err) {
			throw (err.response.data.error)
		}
	},

	writeDataToSpot: async (dataToWrite) => {
		try {
			const res = await Axios.post(`${config.SPOTWS_URL}/ingest/22?asyncCall=false`, dataToWrite, {
				headers: {
					"x-location-token": await AuthService.fetchAuthKey(),
					"authorization": process.env.REACT_APP_AUTHORIZATION_KEY,
					"Content-Type": "application/json"
				},
			},
			);
			return res.data;
		} catch (err) {
			throw (err.response.data.error)
		}
	},

	getAssetId: async (spaceId) => {
		try {
			const res = await Axios.get(`${config.PRODWS_URL}/api/devices/asset/fetch?identifier=space&id=${spaceId}`, {
				headers: {
					"licenseKey": process.env.REACT_APP_LICENSE_KEY,
				}
			});
			return res.data;
		} catch (err) {
			throw (err.response.data.error)
		}
	},

	getDeviceAssetId: async (id) => {
		try {
			const res = await Axios.get(`${config.PRODWS_URL}/api/devices/asset/fetch?identifier=deviceassetid&id=${id}`, {
				headers: {
					"licenseKey": process.env.REACT_APP_LICENSE_KEY,
				}
			});
			return res.data;
		} catch (err) {
			throw (err.response.data.error)
		}
	},

	getAssetIdFromDeviceAssetId: async (deviceAssetId) => {
		try {
			const res = await Axios.get(`${config.PRODWS_URL}/api/devices/asset/fetch?identifier=deviceassetid&id=${deviceAssetId}`, {
				headers: {
					"licenseKey": process.env.REACT_APP_LICENSE_KEY,
				}
			});
			return res.data;
		} catch (err) {
			throw (err.response.data.error)
		}
	},

	getCountFromSpot: async (assetIdArr) => {
		try {
			const res = await Axios.post(`${config.SPOTWS_URL}/assets/data/24/current`, assetIdArr, {
				headers: {
					"x-location-token": await AuthService.fetchAuthKey(),
					"authorization": process.env.REACT_APP_AUTHORIZATION_KEY,
					"Content-Type": "application/json"
				},
			},
			);
			return res.data;
		} catch (err) {
			throw (err.response.data.error)
		}
	},

	getTimDataFromSpot: async (assetIdArr) => {
		try {
			const res = await Axios.post(`${config.SPOTWS_URL}/assets/data/125/current`, assetIdArr, {
				headers: {
					"x-location-token": await AuthService.fetchAuthKey(),
					"authorization": process.env.REACT_APP_AUTHORIZATION_KEY,
					"Content-Type": "application/json"
				},
			},
			);
			return res.data;
		} catch (err) {
			throw (err.response.data.error)
		}
	},

	uploadFileTos3: async (file) => {
		// The snapshot service takes the S3 key from the form field name, so the
		// field name is the file name without its extension.
		const fieldName = file.name.replace(/\.[^/.]+$/, "");
		var data = new FormData();
		data.append(fieldName, file);
		try {
			const res = await Axios.post(`${config.CALIBRATION_TOOL_SNAPSHOTS}/api/upload`, data, {
				headers: {
					"Authorization": `Bearer ${await AuthService.fetchAuthKey()}`,
					'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
				},
			},
			);
			return res.data;
		} catch (err) {
			throw (err.response.data.error)
		}
	},

	writeDataToTIMpSpot: async (dataToWrite) => {
		try {
			const res = await Axios.post(`${config.SPOTWS_URL}/ingest/29?asyncCall=false`, dataToWrite, {
				headers: {
					"x-location-token": await AuthService.fetchAuthKey(),
					"authorization": process.env.REACT_APP_AUTHORIZATION_KEY,
					"Content-Type": "application/json"
				},
			},
			);
			return res.data;
		} catch (err) {
			console.error(err);
			throw (err.response.data.error)
		}
	},

	writeDataToTim4Spot: async (dataToWrite) => {
		try {
			const res = await Axios.post(`${config.SPOTWS_URL}/ingest/23?asyncCall=false`, dataToWrite, {
				headers: {
					"x-location-token": await AuthService.fetchAuthKey(),
					"authorization": process.env.REACT_APP_AUTHORIZATION_KEY,
					"Content-Type": "application/json"
				},
			});
			return res.data;
		} catch (err) {
			console.error(err);
			throw (err.response.data.error)
		}
	},

	sendDownlinkToDevice: async (payload) => {
		try{
			const authKey = await AuthService.fetchAuthKey();
			const myHeaders = new Headers();
			myHeaders.append("Content-Type", "application/json");
			myHeaders.append("Authorization", `Bearer ${authKey}`);

			const requestOptions = {
				method: "POST",
				headers: myHeaders,
				body: JSON.stringify(payload),
				redirect: "follow"
			};

			const response = await fetch(`${config.LORAWAN_DEBUG_URL}/api/debug-mode`, requestOptions);
			const result = await response.text();
			return { status: response.status, data: result };
		}catch (e){
			console.error(e);
			throw e;
		}

	}

}
export default AuthService;